// extracted by mini-css-extract-plugin
export default {"iconButton":"MenuButtonTemplate_iconButton__8rNNJ"};